export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="relative rounded-lg overflow-hidden bg-gradient-to-br from-background-100 via-background-100 to-primary-500/5 border border-background-200/60">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-12">
            <div className="flex-1 w-full text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-4">
                多端观影
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                随时随地，畅享观影
              </h2>
              <p className="mt-4 text-foreground-500 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0">
                天堂影院全面适配电脑、平板和手机端，无论您身在何处，打开浏览器即可流畅观影。
                支持 Chromecast 与 AirPlay 投屏，大屏看片更过瘾。
              </p>
              <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-background-200 border border-background-300/40 text-sm text-foreground-600 whitespace-nowrap">
                  <i className="ri-computer-line text-base text-secondary-400"></i>
                  网页端
                </span>
                <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-background-200 border border-background-300/40 text-sm text-foreground-600 whitespace-nowrap">
                  <i className="ri-tablet-line text-base text-secondary-400"></i>
                  平板端
                </span>
                <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-background-200 border border-background-300/40 text-sm text-foreground-600 whitespace-nowrap">
                  <i className="ri-smartphone-line text-base text-secondary-400"></i>
                  手机端
                </span>
              </div>
            </div>

            <div className="flex-shrink-0 w-full max-w-[280px] aspect-[9/16] rounded-lg overflow-hidden bg-background-200 border border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20dark%20cinema%20streaming%20interface%20with%20movie%20poster%20thumbnails%2C%20warm%20golden%20accent%20UI%20elements%2C%20minimalist%20dark%20theme%20design%2C%20elegant%20gradient%20background%2C%20floating%20phone%20on%20soft%20dark%20surface%2C%20modern%20app%20interface%20mockup%20with%20cinematic%20mood&width=560&height=996&seq=app-mockup-2026&orientation=portrait"
                alt="天堂影院 - 手机端观影体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}